import { V2 } from '@eventr/common'
import { Stack } from '@mui/material'
import { renderComponents } from '../../../v2Utils'

interface IPlainDTProps {
    data: V2
    screenType: string
}
export const PlainDT = ({ data, screenType }: IPlainDTProps) => {
    return (
        <Stack padding="16px">
            {renderComponents(
                data.data,
                data.rendererOptions?.components ?? []
            )}
        </Stack>
    )
}
